import { observable, computed } from 'mobx';
import {FlashMessage} from '../../types';

export class FlashModel {
  @observable
  messages: Array<FlashMessage> = [];

  @observable
  queue: Promise<any> = null;

  @computed
  get unseen(): Array<FlashMessage> {
    return this.messages.filter(msg => !msg.seen).slice(0, 1);
  }
}